import { ISwAppApi } from "../../interfaces-and-types";
import { authorizationUrls } from "./authorizationUrls";
import { accountProfileUrls } from "./accountProfileUrls";
import { accountSettingsUrls } from "./accountSettingsUrls";
import { accountStatementUrls } from "./accountStatementUrls";
import { analyticsUrls } from "./analyticsUrls";
import { balancesUrls } from "./balancesUrls";
import { bankAccountUrls } from "./bankAccountUrls";
import { beneficiaryUrls } from "./beneficiaryUrls";
import { customerUrls } from "./customerUrls";
import { dashboardUrls } from "./dashboardUrls";
import { generalSearchUrls } from "./generalSearchUrls";
import { merchantAccountUrls } from "./merchantAccountUrls";
import { merchantDedicatedTopUpAccountUrls } from "./merchantDedicatedTopUpAccountUrls";
import { onboardingUrls } from "./onboardingUrls";
import { paymentLinksUrls } from "./paymentLinksUrls";
import { payoutsUrls } from "./payoutsUrls";
import { productsUrls } from "./productsUrls";
// import { staffUserSettingsUrls } from "./staffUserSettingsUrls";
import { switchappSupportedServicesUrls } from "./switchappSupportedServicesUrls";
import { teamAndSecurityUrls } from "./teamAndSecurityUrls";
import { transactionsUrls } from "./transactionsUrls";
import { transfersUrls } from "./transfersUrls";
import { loansUrls } from "./loansUrls";
import { virtualAccountTransferRefundsUrls } from "./virtualAccountTransferRefundsUrls";
import { invoicesUrls } from "./invoicesUrls";

type TSwAppUrls = { [key in keyof ISwAppApi]: string };

export const swAppCombinedUrls: TSwAppUrls = {
  ...authorizationUrls,
  ...accountProfileUrls,
  ...accountStatementUrls,
  ...accountSettingsUrls,
  ...analyticsUrls,
  ...beneficiaryUrls,
  ...balancesUrls,
  ...bankAccountUrls,
  ...customerUrls,
  ...dashboardUrls,
  ...generalSearchUrls,
  ...invoicesUrls,
  ...loansUrls,
  ...merchantAccountUrls,
  ...merchantDedicatedTopUpAccountUrls,
  ...onboardingUrls,
  ...paymentLinksUrls,
  ...payoutsUrls,
  ...productsUrls,
  // ...staffUserSettingsUrls,
  ...switchappSupportedServicesUrls,
  ...teamAndSecurityUrls,
  ...transactionsUrls,
  ...transfersUrls,
  ...virtualAccountTransferRefundsUrls,
};
